const data = {
  id: 1,
  title: 'Rearrange the words to make the correct sentence',
  subTitle: 'Sắp xếp lại các từ để tạo thành câu đúng',
  question: 'What are they?',
  answer: 'What are they',
};

export default data;
